import { makeStyles, tokens } from '@fluentui/react-components'
import { codeStyles, mediaStyles, tableStyles } from './bubble-content-styles'

const actionsWrapperBase = {
  display: 'flex',
  alignItems: 'center',
  padding: `${tokens.spacingHorizontalXS} ${tokens.spacingHorizontalXS} ${tokens.spacingHorizontalS}`,
  gap: tokens.spacingHorizontalXXS,
}

export const useConversationStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${tokens.spacingHorizontalS} 0`,
    gap: tokens.spacingHorizontalXS,
    flexGrow: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  infoNote: {
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    paddingBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase100,
  },
})

export const useChatBubbleStyles = makeStyles({
  button: {
    padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalXXS}`,
  },
  bubbleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: '100%',
    position: 'relative',
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
  },
  bubbleWrapperUser: {
    alignItems: 'flex-end',
  },
  bubble: {
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    overflow: 'auto',
    maxWidth: '90%',
    wordBreak: 'break-word',
    fontSize: tokens.fontSizeBase200,
    fontFamily: tokens.fontFamilyBase,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase200,
    '& h1, & h2, & h3, & h4, & h5, & h6': { lineHeight: 'normal' },
    ...tableStyles,
    ...codeStyles,
    ...mediaStyles,
  },
  bubbleUser: {
    borderRadius: tokens.borderRadius3XLarge,
    borderTopRightRadius: tokens.borderRadiusSmall,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorBrandBackground2Hover,
    color: tokens.colorNeutralForeground2,
  },
  bubbleAssistant: {
    backgroundColor: 'transparent',
    border: 'none',
    color: tokens.colorNeutralForeground2,
  },
  bubblePreWrap: {
    whiteSpace: 'pre-wrap',
  },
  bubbleAssistantBodyText: {
    // Bayer stylesheet sets per-selector font rules (e.g. p.BayerBodyTextFull → Times New Roman).
    // When the response has Bayer classes but no table, force Fluent base font so the
    // bubble reads consistently with the rest of the UI.
    '& *': {
      fontFamily: `${tokens.fontFamilyBase} !important`,
      fontSize: `${tokens.fontSizeBase200} !important`,
    },
  },
  bubbleAssistantTable: {
    width: '100%',
    alignSelf: 'stretch',
    maxWidth: '100%',
    overflow: 'visible',
  },
  actionsWrapper: {
    ...actionsWrapperBase,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 300ms',
  },
  actionsWrapperVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  assistantActionsWrapper: {
    ...actionsWrapperBase,
  },
  timestamp: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground4,
  },
})

export const useLoadingBubbleStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXL}`,
  },
  dot: {
    width: tokens.spacingHorizontalS,
    height: tokens.spacingVerticalS,
    borderRadius: '50%',
    backgroundColor: tokens.colorNeutralForeground3,
    animationName: {
      '0%, 100%': {
        transform: 'translateY(0) scale(0.6)',
        opacity: 0.4,
      },
      '50%': {
        transform: 'translateY(-8px) scale(1)',
        opacity: 1,
      },
    },
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  },
  dot1: {
    animationDelay: '0s',
  },
  dot2: {
    animationDelay: '0.2s',
  },
  dot3: {
    animationDelay: '0.4s',
  },
})
